<template>
  <div id="basic-layout">
    <a-layout>
      <a-layout-header class="header">
        <a-row>
          <a-col :span="12">
            <div class="title-bar">
              <router-link to="/">
                <img class="logo" src="@/assets/logo.png" alt="logo" />
                <div class="title">贡有质</div>
              </router-link>
            </div>
          </a-col>
          <a-col :span="12" style="text-align: right">
            <a-button
              class="login-button"
              type="primary"
              @click="ToUserLoginPage"
              >登录/注册
            </a-button>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content class="content">
        <router-view />
      </a-layout-content>

      <a-layout-footer class="footer">
        <div class="footer-content">
          <div class="footer-nav">
            <a
              v-for="link in navLinks"
              :key="link.name"
              :href="link.href"
              class="nav-link"
            >
              {{ link.name }}
            </a>
          </div>
          <div class="footer-copyright">
            <p>© 北京聚客帮科技发展有限公司 版权所有</p>
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >备案号：京ICP备17063633号-4</a
            >
          </div>
        </div>
      </a-layout-footer>
    </a-layout>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";

// 导航链接
const navLinks = [
  { name: "首页", href: "/" },
  { name: "关于我们", href: "/about" },
  { name: "服务项目", href: "/services" },
  { name: "联系我们", href: "/contact" },
  { name: "隐私政策", href: "/privacy" },
  { name: "使用条款", href: "/terms" },
];

// 路由实例
const router = useRouter();

// 导航至用户登录页面
const ToUserLoginPage = () => {
  router.push("/user-login");
};
</script>

<style scoped>
#basic-layout .footer {
  background: #efefef;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
}

#basic-layout .content {
  margin-bottom: 120px;
  background: linear-gradient(to right, #fff, #bcb9b9);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-nav {
  margin-bottom: 16px;
}

.nav-link {
  color: #bfbaba;
  text-decoration: none;
  margin: 0 16px;
  font-size: 14px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #1890ff;
}

.footer-copyright {
  font-size: 12px;
  color: #7e7a7a;
  line-height: 1.5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-link {
    margin: 8px 12px;
  }
}

.header {
  background: #fff;
  height: 60px;
}

.title-bar {
  display: flex;
  align-items: center;
}

.title-bar a {
  text-decoration: none;
  display: flex;
  align-items: center;
  color: inherit;
}

.title {
  color: #262626;
  font-size: 24px;
  font-weight: 600;
  margin-left: 16px;
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", "Heiti SC",
    "WenQuanYi Micro Hei", sans-serif;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.title:hover {
  color: #1890ff;
  text-shadow: 0 2px 4px rgba(24, 144, 255, 0.3);
}

.logo {
  height: 48px;
}
</style>
